import React from "react";
import HeaderSection from "./HeaderSection";
import WhyMarketPulse from "./WhyMarketPulse";
import WhatIsMarketPulse from "./WhatIsMarketPulse";
import "./style.css";
import { Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";

const MarketPulse = () => (
  <Layout>
    <Content>
      <Row
        className="dvt-section pr4 pl4 pb2 pt2 dvt-main"
        justify="space-around"
        align="middle"
        gutter={[0, 24]}
      >
        <Col span={24} className="marketpulse-page">
          <HeaderSection />
          <WhyMarketPulse />
          <WhatIsMarketPulse />
        </Col>
      </Row>
    </Content>
  </Layout>
);

export default MarketPulse; 